import {origins} from '../constants/general-constants'

export const getLinkedinClientId = () => {
  const origin = window.location.origin
  if (origin === origins.localhost) {
    return '77xplb341hdllc'
  } else if (origin === origins.develop) {
    return '777lixynpuzcmm'
  } else if (origin === origins.production) {
    return '77icchs9arqrx7'
  }
}

export const getLeverRedirectUri = () => {
  const origin = window.location.origin
  if (origin === origins.production) {
    return 'https://auth.lever.co/authorize?client_id=jDqq52wnX2Ylq2yNI8US1hqk2ATq23uL&redirect_uri=https://app.hirevibes.io/settings/eos-account&state=vgG5sHr6&response_type=code&scope=opportunities:write:admin%20postings:read:admin%20users:read:admin%20offline_access&prompt=consent&audience=https://api.lever.co/v1/'
  } else {
    return 'https://sandbox-lever.auth0.com/authorize?client_id=BEVlwSskyHLzIj9dw4GqaD2KGoG6fTZh&redirect_uri=http://localhost:8080/settings/eos-account&state=vgG5sHr6&response_type=code&scope=opportunities:write:admin%20postings:read:admin%20users:read:admin&prompt=consent'
  }
}

export const getGithubClientId = () => {
  const origin = window.location.origin
  if (origin === origins.localhost) {
    return '60491da0080a6878167b'
  } else if (origin === origins.develop) {
    return 'e27f1169ab140e2b3b19'
  } else if (origin === origins.production) {
    return '362cc26bb4ae6483fcc2'
  }
}

export const redirectUri = () => {
  const origin = window.location.origin
  if (origin === origins.localhost) {
    return 'http%3A%2F%2Flocalhost%3A8080%2Flogin'
  } else if (origin === origins.develop) {
    return 'https%3A%2F%2Fdevelop.hirevibes.io%2Flogin'
  } else if (origin === origins.production) {
    return 'https%3A%2F%2Fapp.hirevibes.com%2Flogin'
  }
}

export const googleRedirectUri = () => {
  const origin = window.location.origin
  if (origin === origins.localhost) {
    return 'http%3A%2F%2Flocalhost%3A8080'
  } else if (origin === origins.develop) {
    return 'https%3A%2F%2Fdevelop.hirevibes.io'
  } else if (origin === origins.production) {
    return 'https%3A%2F%2Fapp.hirevibes.com'
  }
}

export const getGoogleClientId = () => {
  const origin = window.location.origin
  if (origin === origins.localhost) {
    return '1009111036118-j39hrspkbcasrgb70uadv8dbi8al0bfk.apps.googleusercontent.com'
  } else if (origin === origins.develop) {
    return '155798073442-be11qr1po69ooiiegt2ovpd1srlofjst.apps.googleusercontent.com'
  } else if (origin === origins.production) {
    return '20782532208-d740c9m5chc9l0tb2luj8lmtiq806inb.apps.googleusercontent.com'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js